export enum ChartElementType {
  Bar = 'Bar',
  Line = 'Line',
  TableDataOnly = 'TableDataOnly',
}
